type SupportedCurrencyCodes = 'USD' | 'CAD';
type SupportedLocales = 'en-US' | 'en-CA' | 'fr-CA';

const supportedLocales: SupportedLocales[] = ['en-US', 'en-CA', 'fr-CA'];

export const formatPrice = (priceCents?: number, currencyCode?: SupportedCurrencyCodes) => {
  if (priceCents === undefined) {
    return '';
  }

  if (!currencyCode) {
    currencyCode = 'USD';
  }

  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 2,
  };

  if (priceCents % 100 === 0) {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  }

  return new Intl.NumberFormat(supportedLocales, options).format(priceCents / 100);
};
